import type { PeriodPreset } from "@/hooks/usePeriodFilter";
import { loadAdminPreferences } from "@/lib/adminSettings";

export type PeriodNavigationSearch = {
  period: PeriodPreset;
  from?: string;
  to?: string;
};

const validPeriods = new Set<PeriodPreset>([
  "today",
  "yesterday",
  "7d",
  "14d",
  "30d",
  "90d",
  "6m",
  "1y",
  "all",
  "custom",
]);

export function getPeriodNavigationSearch(search: Record<string, unknown>): PeriodNavigationSearch {
  const rawPeriod = typeof search.period === "string" ? search.period : loadAdminPreferences().defaultPeriod;
  const period = validPeriods.has(rawPeriod as PeriodPreset) ? (rawPeriod as PeriodPreset) : "30d";

  if (period !== "custom") {
    return { period };
  }

  const nextSearch: PeriodNavigationSearch = { period };
  if (typeof search.from === "string") nextSearch.from = search.from;
  if (typeof search.to === "string") nextSearch.to = search.to;

  return nextSearch;
}

export function buildPathWithPeriod(path: string, search: PeriodNavigationSearch): string {
  const params = new URLSearchParams();
  params.set("period", search.period);

  if (search.period === "custom") {
    if (search.from) params.set("from", search.from);
    if (search.to) params.set("to", search.to);
  }

  const query = params.toString();
  return query ? `${path}?${query}` : path;
}
